import { IonContent, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { PropsWithChildren } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import styles from "@components/pageTypes/Page.module.css";
import PageTitle, { UsableImageName } from "@components/text/PageTitle";
import { imageUrl } from "@utils/imageUtils";

type Props = PropsWithChildren<{
  containerClassName?: string;
  contentClassName?: string;
  helmetKey: string;
  imageName: UsableImageName | null;
  titleKey: string | null;
}>;

const ExpertPage = ({
  children,
  containerClassName = "",
  contentClassName = "",
  helmetKey,
  imageName,
  titleKey
}: Props) => {
  const intl = useIntl();

  return (
    <IonPage>
      <Helmet>
        <title>{intl.formatMessage({ id: helmetKey })}</title>
      </Helmet>
      <IonToolbar className={styles.bar + " ion-hide-lg-up"}>
        <IonTitle className={styles.logoTitle} slot="start">
          <img
            alt={intl.formatMessage({ id: "accessibility.altTags.whiteLogo" })}
            className={styles.logoImage}
            src={imageUrl("logoWhite")}
          />
        </IonTitle>
        <IonMenuButton className={styles.toggle} slot="end" />
      </IonToolbar>
      <IonContent>
        <div className={`${containerClassName} ${styles.expertPageContainer}`}>
          {imageName && titleKey && <PageTitle imageName={imageName} titleKey={titleKey} />}
          <div className={`${contentClassName} ${styles.expertPageContent}`}>{children}</div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ExpertPage;
